import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// RxJS
import { Observable, tap } from 'rxjs';

// Services
import { StateService } from '../../settings/services/state.service';
import { NetworkService } from '@modules/core/services/network.service';

// Types
import { GlobalState } from '../../settings/types/global-state';

// Decorators
import { warmUpObservable } from '@decorators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // Private
  private state?: GlobalState;

  /**
   * Constructor
   */

  constructor(
    private networkService: NetworkService,
    private stateService: StateService,
    private router: Router
  ) {
    // State
    this.stateService.getState().subscribe(state => this.state = state);
  }

  /**
   * Methods
   */

  @warmUpObservable
  login(email: string, password: string): Observable<any> {
    return this.networkService.login(email, password)
      .pipe(
        tap(result => {
          if (result.accessToken) {
            this.stateService.updateState({accessToken: result.accessToken, account: result.user});
            this.router.navigate(['']);
          }
        })
      );
  }

  logout(): void {
    this.stateService.updateState({account: undefined, accessToken: undefined});
    this.router.navigate(['login']);
  }

  public isAuthenticated(): boolean {
    return !!this.state?.accessToken?.length;
  }

  validateToken(token: string): Observable<any> {
    return this.networkService.inviteValidate(token);
  }

  regenerateToken(userId: string): Observable<any> {
    return this.networkService.regenerateToken(userId);
  }

  resetPassword(userId: string): Observable<any> {
    return this.networkService.resetPassword(userId);
  }

  completeRegistration(email: string, password: string, name?: string): Observable<any> {
    return this.networkService.completeRegistration(email, password, name);
  }


}
